let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8V7My")).then(() => parcelRequire('l3z6A'));